import React, { useMemo } from "react";
import Button from "@mui/material/Button";
import { CellWrapper } from "./cellWrapper";
import { useTranslation } from "react-i18next";
import { IconButton } from "@mui/material";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
export const DeleteRowButton = (props) => {
  const {
    value: initialValue,
    row: { index, original },
    column: { id, shouldExclude, buttonLabel, showDeleteIconOnly = false },
    updateGridData,
    data,
  } = props;
  const { t } = useTranslation();

  const isShouldExclude = useMemo(() => {
    if (typeof shouldExclude === "function") {
      return shouldExclude(initialValue, original, data, index);
    }
    return false;
  }, [initialValue, original, data, index]);

  const handleClick = (e) => {
    updateGridData(index, id, true, true, "");
  };

  if (isShouldExclude) {
    return <CellWrapper showBorder {...props}></CellWrapper>;
  }

  return (
    <CellWrapper showBorder={true} {...props}>
      {!showDeleteIconOnly ? (
        <Button
          onClick={handleClick}
          fullWidth
          variant="contained"
          color="secondary"
          style={{
            height: "28px",
          }}
        >
          {Boolean(buttonLabel) ? t(buttonLabel) : t("Delete")}
        </Button>
      ) : (
        <IconButton
          onClick={handleClick}
          sx={{
            width: "35x",
            height: "35px",
            "&:hover": { background: "#fccfcf" },
            color: "#ff2626",
          }}
        >
          <DeleteOutlineIcon />
        </IconButton>
      )}
    </CellWrapper>
  );
};
